// Setup app's Firebase project configuration
let firebaseConfig = {
  apiKey: "AIzaSyA5WoJ_lkYFyKHFVmpn7VgZgU9jjvsuKbw",
  authDomain: "brendan-portfolio.firebaseapp.com",
  databaseURL: "https://brendan-portfolio.firebaseio.com",
  projectId: "brendan-portfolio",
  storageBucket: "brendan-portfolio.appspot.com",
  messagingSenderId: "999975491629",
  appId: "1:999975491629:web:99c426866f07343a8c40a4",
  measurementId: "G-HNBG2LHBC9"
};

// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import * as firebase from "firebase/app";
// Add the Firebase services that you want to use
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";
import "firebase/analytics";
// Import emailJS package for sending email via javascript
import emailjs from "emailjs-com";
import defaults from "./Foundation/static-objs";
import Experience from "../models/experience";
// import sweetalert.js for displaying alerts
let Swal = require("sweetalert2");
// Set configurations
let Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  onOpen: toast => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  }
});

let mixins = {
  data() {
    return {
      skills: []
    };
  },

  computed: {
    $firebase() {
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
        firebase
          .firestore()
          .enablePersistence()
          .catch(e => {
            if (err.code == "failed-precondition") {
              console.log("Multiple tabs open, persistence can only be enabled in one tab at a time.");
            } else if (err.code == "unimplemented") {
              console.log("The current browser does not support all of the features required to enable persistence.");
            }
          });
      }
      return firebase;
    },

    $firestore() {
      return this.$firebase.firestore();
    },
    $storage() {
      return this.$firebase.storage().ref();
    },
    $emailjs() {
      return emailjs;
    },

    $swal() {
      return Swal;
    },

    $toast() {
      return Toast;
    }
  },

  methods: {
    mixin_defaults() {
      this.$firestore
        .collection("settings")
        .doc("defaults")
        .set({
          firstName: "Brendan",
          lastName: "Ejike",
          author: "Brendan Ejike",
          primary_email: "ejike.br@gmail.com",
          secondary_email: "br.onekode@gmail.com",
          phone_styled: "(+234)810 039 5180",
          phone: "+2348100395180",
          job: "Software Developer",
          home_address: "D166, Army Post Service Ojo, Lagos, Nigeria",
          home_map: "https://goo.gl/maps/q3prp1VdSj848nz86",
          work_address: "De living, Opposite Little Africa, <br/>Ihiagwa FUTO, Owerri, Nigeria",
          work_map: "https://goo.gl/maps/ELgt76GJ9cVsfNmi9",
          facebook_url: "https://facebook.com/codecaptn",
          twitter_url: "https://twitter.com/codecaptn",
          linkedIn_url: "https://linkedin.com/in/codecaptn",
          github_url: "https://github.com/f0rx",
          dribble_url: "https://dribbble.com/codecaptn",
          created_at: this.$firebase.firestore.FieldValue.serverTimestamp(),
          updated_at: this.$firebase.firestore.FieldValue.serverTimestamp()
        })
        .then(() => {
          console.log("Defaults added successfully!");
        })
        .catch(error => {
          console.error("Error adding document: ", error);
        });
    },

    mixin_set_skills() {
      this.$firestore
        .collection("settings")
        .doc("skills")
        .set(defaults.skills())
        .then(() => {
          console.log("Skills written successfully!");
        })
        .catch(e => {
          console.error("Error adding document: ", e);
        });
    },

    mixin_set_categories() {
      this.$firestore
        .collection("settings")
        .doc("categories")
        .set(defaults.categories())
        .then(() => {
          console.log("Categories added to Cloud DB");
        })
        .catch(e => {
          console.error("Error adding document: ", e);
        });
    },

    mixin_set_stacks() {
      let stacks = []; // Create an empty array
      defaults.stacks().forEach(stack => {
        if (stack.location.includes("gif")) this.getStackDownloadUrl(stacks, stack, "gif"); // Call function & pass in arguments
        if (stack.location.includes("png")) this.getStackDownloadUrl(stacks, stack, "png");
      });
    },

    mixin_set_workExp() {
      let experiences = defaults.work_experience().map(xp => {
        xp.setUpdatedAt(this.$firebase.firestore.Timestamp.fromDate(new Date()));
        return Experience.converter.toDocument(xp);
      });

      this.$firestore
        .collection("settings")
        .doc("work")
        .set({ experiences })
        .then(() => {
          console.log("Work Experience added to Cloud DB");
        })
        .catch(e => {
          console.error("Error adding document: ", e);
        });
    },

    async documentExists(collection, document) {
      var data = await this.$firestore
        .collection(collection)
        .doc(document)
        .get();
      return data.exists;
    },

    async updateDocument(collection, doc, data) {
      await this.$firestore
        .collection(collection)
        .doc(doc)
        .update({ data }, { merge: true })
        .then(() => {
          console.log("Data Updated!");
        })
        .catch(e => {
          console.error("Error updating document: ", e);
        });
    },

    getStackDownloadUrl(stacks, stack, ext) {
      this.$storage
        .child(`portfolio/${this.$helper.slugify(stack.id, "-")}.${ext}`) // Get storage path
        .getDownloadURL() // Get download Url (Full Path)
        .then(url => {
          stack.location = url; // Set the new URL to the location field
          stacks.push(stack); // Push updated value to stacks array above

          this.$firestore
            .collection("settings")
            .doc("stacks")
            .set({ stacks }) // Save the updated array to Cloud
            .then(() => {
              console.log("Stacks added to Cloud DB");
            })
            .catch(e => {
              console.error("Error adding document: ", e);
            });
        });
    },

    async updateDisplayImageUrl() {
      var url = await this.getDownloadURL("portfolio/user/me.jpg");
      this.$firestore
        .collection("settings")
        .doc("defaults")
        .set({ profileImageUrl: url }, { merge: true })
        .then(() => console.log("Profile Url updated"))
        .catch(e => console.log(e));
    },

    async updateCVUrl() {
      var url = await this.getDownloadURL("portfolio/CV/CV.pdf");

      this.$firestore
        .collection("settings")
        .doc("defaults")
        .set({ CVUrl: url }, { merge: true })
        .then(() => console.log("CV Url updated"))
        .catch(e => console.log(e));
    },

    async getDownloadURL(path) {
      return await this.$storage
        .child(path)
        .getDownloadURL();
    }
  }
};

export default mixins;